export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-12 text-center">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">联系我们</h2>
          <p className="text-sm md:text-base text-foreground-400">有料你就来！欢迎投稿爆料，或咨询合作事宜</p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="rounded-xl bg-background-100 border border-background-200/60 p-8 md:p-10 text-center">
            <div className="w-16 h-16 mx-auto mb-5 rounded-full bg-primary-100 flex items-center justify-center">
              <i className="ri-mail-send-line text-primary-500 text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-foreground-950 mb-3">投稿与合作</h3>
            <p className="text-sm text-foreground-400 leading-relaxed mb-6">
              如果你有独家爆料、精彩内容投稿或商业合作需求，欢迎通过以下方式联系我们。
              我们的编辑团队将在24小时内回复你的消息。
            </p>

            <form
              id="contact-form"
              data-readdy-form
              className="space-y-4 text-left"
            >
              <div>
                <input
                  type="text"
                  name="name"
                  placeholder="你的昵称"
                  className="w-full px-4 py-3 text-sm rounded-lg bg-background-50 border border-background-200/60 focus:border-primary-300 focus:outline-none transition-colors"
                />
              </div>
              <div>
                <input
                  type="email"
                  name="email"
                  placeholder="你的邮箱"
                  className="w-full px-4 py-3 text-sm rounded-lg bg-background-50 border border-background-200/60 focus:border-primary-300 focus:outline-none transition-colors"
                />
              </div>
              <div>
                <textarea
                  name="message"
                  rows={4}
                  maxLength={500}
                  placeholder="请描述你的投稿内容或合作意向（限500字）"
                  className="w-full px-4 py-3 text-sm rounded-lg bg-background-50 border border-background-200/60 focus:border-primary-300 focus:outline-none transition-colors resize-none"
                ></textarea>
              </div>
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="absolute opacity-0 pointer-events-none"
                style={{ position: 'absolute', left: '-9999px', top: '-9999px' }}
              />
              <button
                type="submit"
                className="w-full py-3.5 bg-primary-500 text-background-50 font-bold text-sm rounded-lg hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
              >
                提交信息
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}